// Texty bloku nejnižší ceny a grafu vývoje ceny (priceHistory.js).
export default {
  labels: {
    omnibus: 'Nejnižší cena za 30 dnů před slevou',
    low30: 'Nejnižší cena za posledních 30 dnů',
    atMin: '· aktuálně nejnižší cena',
    toggle: 'Vývoj ceny',
    title: 'Vývoj ceny',
    from: 'od',
    today: 'dnes',
    caption: 'Prodejní cena s DPH',
    captionBand: 'růžové pásmo = probíhající akce',
    refOmnibus: 'Nejnižší cena 30 dnů před slevou',
    refOmnibusShort: '30 dnů před slevou',
    refLow30: 'Nejnižší cena za posledních 30 dnů',
    refLow30Short: 'posledních 30 dnů',
  },
  /** aria-label grafu; min/max/now = holá čísla, sym = symbol měny */
  aria: (from, min, max, now, sym) =>
    'Vývoj prodejní ceny od ' + from + ', rozpětí ' + min + ' až ' + max + ' ' + sym + ', aktuálně ' + now + ' ' + sym,
};
